import React from "react";
import { Avatar } from "antd";
import { getImageLink } from "../../services/asset";

const IndexAvatar = ({ url, size, className }) => {
  let image = {
    backgroundImage: `url(${getImageLink(url)})`
  };

  return (
    <Avatar
      style={url ? image : undefined}
      icon={!url ? "user" : undefined}
      size={size}
      className={className}
    />
  );
};

IndexAvatar.defaultProps = {
  url: "",
  size: "default",
  className: ""
};

export default React.memo(IndexAvatar);



// WEBPACK FOOTER //
// ./src/components/IndexAvatar/IndexAvatar.tsx